// extracted by mini-css-extract-plugin
module.exports = {"EditorPersonal":"_2n8dXwwn","titleBlock":"_10YkD_L8","title":"_2HGeiFIb","scrollDiv":"_1cMjsPc6","titleContainer":"_12Zg3u7w","nameInputs":"_3nD5DDQX","autoSaving":"X-PnfSso","autoSaved":"_2UuqXZsf","saveContent":"_3ZOdUcXx","emailContent":"_3JbPkac_"};
    if(module.hot) {
      // 1754515035694
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  